/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
 */
export interface GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInner
     */
    'transactionDetailType': GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
}

export const GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOf1CardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


